<template>
  <router-link
      :to="{name: 'donateBlood'}"
      type="button"
      class="btn button-section"
      id="btn-schedule"
  >
    SCHEDULE APPOINTMENT
  </router-link>
</template>

<script>
export default {
  name: "cssButton",
  data(){
    return {
      btnHref: "#"
    }
  }
}
</script>

<style scoped>
#btn-schedule {
  display: flex;
}
</style>
